import { getAllOrgDetails } from "../../store/api";
import { store } from "../../store/store";
import { LocalStorageUtil } from "../../utils/LocalStorageUtil";
import { showToast } from "../../utils/tools";

export const getOrganizationList = (
  api: any,
  ignoreFilter: boolean = false,
  callback: any,
  isAllOrgs = false
) => {
  const dispatch = store.dispatch;
  dispatch(
    getAllOrgDetails({
      callback: callback,
      api: api,
      ignoreFilter: ignoreFilter,
      isAllOrgs,
    })
  );
};
